import React, { useState } from "react";

import { Fleet } from "Models/fleet";

import { MemberTabs, MemberTabsProps } from "../../../../../People/Members";
import { MembersTable } from "./MembersTable";
import { TeamsTable } from "./TeamsTable";

interface MembersAndTeamsSectionProps {
  fleet: Fleet;
}

export const MembersAndTeamsSection = (props: MembersAndTeamsSectionProps) => {
  const { fleet } = props;
  const [currentActive, setCurrentActive] = useState<MemberTabsProps["currentActive"]>("members");

  return (
    <div>
      <MemberTabs currentActive={currentActive} setCurrentActive={setCurrentActive} />

      {currentActive === "members" ? <MembersTable fleet={fleet} /> : <TeamsTable fleet={fleet} />}
    </div>
  );
};
